import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const UpperNavSettings = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [supportEmail, setSupportEmail] = useState('');
  const [facebookUrl, setFacebookUrl] = useState('');
  const [instagramUrl, setInstagramUrl] = useState('');
  const [linkedinUrl, setLinkedinUrl] = useState('');
  const [xUrl, setXUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setLoading(false);
      return;
    }

    const fetchUpperNav = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/admin/upper-nav`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const { settings } = res.data;
        if (settings) {
          setPhoneNumber(settings.phoneNumber || '');
          setSupportEmail(settings.supportEmail || '');
          setFacebookUrl(settings.facebookUrl || '');
          setInstagramUrl(settings.instagramUrl || '');
          setLinkedinUrl(settings.linkedinUrl || '');
          setXUrl(settings.xUrl || '');
        }
      } catch {
        // ignore, will start empty
      } finally {
        setLoading(false);
      }
    };

    fetchUpperNav();
  }, []);

  const handleSave = async () => {
    setError('');
    setSuccess('');
    setSaving(true);
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setError('انتهت صلاحية الجلسة، برجاء تسجيل الدخول مرة أخرى.');
      setSaving(false);
      return;
    }

    try {
      await axios.put(
        `${API_BASE_URL}/api/admin/upper-nav`,
        {
          phoneNumber,
          supportEmail,
          facebookUrl,
          instagramUrl,
          linkedinUrl,
          xUrl,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSuccess('تم حفظ إعدادات الشريط العلوي بنجاح.');
    } catch (err) {
      const message = err.response?.data?.message || 'حدث خطأ أثناء الحفظ.';
      setError(message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p>جاري تحميل إعدادات الشريط العلوي...</p>;
  }

  return (
    <div className="admin-section">
      <h2 className="admin-section-title">إعدادات الشريط العلوي (معلومات الاتصال)</h2>
      <p className="admin-section-subtitle">
        يمكنك هنا تعديل البريد الإلكتروني، رقم الهاتف، وروابط حسابات التواصل الاجتماعي في الشريط
        العلوي للموقع.
      </p>

      {error && <div className="admin-section-error">{error}</div>}
      {success && <div className="admin-section-success">{success}</div>}

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>البريد الإلكتروني</label>
          <input
            type="email"
            value={supportEmail}
            onChange={(e) => setSupportEmail(e.target.value)}
            placeholder="info@example.com"
          />
        </div>
        <div className="admin-field">
          <label>رقم الهاتف</label>
          <input
            type="text"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="+9665xxxxxxxx"
          />
        </div>
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>رابط فيسبوك</label>
          <input
            type="text"
            value={facebookUrl}
            onChange={(e) => setFacebookUrl(e.target.value)}
            placeholder="https://www.facebook.com/yourpage"
          />
        </div>
        <div className="admin-field">
          <label>رابط إنستغرام</label>
          <input
            type="text"
            value={instagramUrl}
            onChange={(e) => setInstagramUrl(e.target.value)}
            placeholder="https://www.instagram.com/yourpage"
          />
        </div>
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>رابط لينكدإن</label>
          <input
            type="text"
            value={linkedinUrl}
            onChange={(e) => setLinkedinUrl(e.target.value)}
            placeholder="https://www.linkedin.com/company/yourpage"
          />
        </div>
        <div className="admin-field">
          <label>رابط X (تويتر سابقاً)</label>
          <input
            type="text"
            value={xUrl}
            onChange={(e) => setXUrl(e.target.value)}
            placeholder="https://x.com/yourhandle"
          />
        </div>
      </div>

      <div className="admin-actions">
        <button
          type="button"
          className="admin-btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'جاري الحفظ...' : 'حفظ الإعدادات'}
        </button>
      </div>
    </div>
  );
};

export default UpperNavSettings;

